import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { dispatch } from '../../store/state/state-manager';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import { postProcess, mergeData } from '../../store/state/actions/action-creators';
import Utils from '../../utils/utils';
import type { Action } from '../../store/state/state-manager';
import { isErrorActionType, promiseHandler } from '../common-helper';
import type { ActionsOut } from '../types';

import { executeGetDescendantsRequest } from './async-request';
import { GET_DESCENDANTS } from './action-creator';

export const getDescendants = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let actionsOut: ActionsOut[] = [];
  return action$.pipe(
    ofType(GET_DESCENDANTS),
    map((action: Action) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((actionInPayload) => executeGetDescendantsRequest(actionInPayload)),
    mergeMap(async (chainedData) => {
      if (chainedData && isErrorActionType(chainedData.type)) {
        actionsOut.push(processDataToDispatchErrorAction(chainedData));
        return actionsOut;
      }
      const { actionInPayload, response } = chainedData;
      const data = {};
      Utils.setIn(data, 'caseInfo.childCases', response?.childCases ?? []);
      const currentPayload = {
        data,
        context: actionInPayload?.context
      };
      actionsOut.push(postProcess(mergeData, currentPayload));
      return actionsOut;
    }),
    map(() => {
      dispatch(actionsOut);
      promiseHandler(actionsOut, actionMgrID);
      actionsOut = [];
      return actionsOut;
    })
  );
};

export default getDescendants;
